import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopunecab() {



const cardData = {
  keyword: " Mumbai to Pune Cabs ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Pune cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Mumbai to Pune convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai to Pune cab travel.",

topPlaces: [
 
  {
    title: "Alibaug",
    description: "Alibaug is a coastal town known for its clean beaches, seaside forts, and relaxed atmosphere. It is ideal for beach outings, water sports, and short ferry rides from Mumbai."
  },
  {
    title: "Matheran",
    description: "Matheran is a unique eco-friendly hill station where vehicles are banned, offering serene walking trails, viewpoints, toy train rides, and panoramic views of the Western Ghats."
  },
   {
    title: "Lonavala",
    description: "Lonavala is a famous hill station near Mumbai known for its misty valleys, waterfalls, caves, and scenic viewpoints. It is a popular weekend getaway for trekking, nature walks, and monsoon road trips."
  },
  {
    title: "Khandala",
    description: "Khandala is a picturesque hill station offering lush green valleys, mountain views, and peaceful surroundings. Visitors can enjoy viewpoints like Tiger's Leap and Duke’s Nose along with refreshing weather."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station famous for its strawberry farms, lush forests, viewpoints, and pleasant climate. Visitors can explore Venna Lake, Arthur’s Seat, and scenic waterfalls."
  },
  {
    title: "Igatpuri",
    description: "Igatpuri is a tranquil hill town known for its misty mountains, waterfalls, and the famous Vipassana meditation center. It is perfect for nature lovers and peace seekers."
  },
  {
    title: "Nashik",
    description: "Nashik is a spiritual and wine capital of India, known for Trimbakeshwar Temple, Sula Vineyards, and the Godavari River ghats. It blends pilgrimage, culture, and modern wine tourism."
  },
  {
    title: "Karjat",
    description: "Karjat is a scenic countryside destination near Mumbai known for trekking trails, rivers, waterfalls, and farm stays. It is ideal for adventure activities and peaceful weekend getaways."
  },
  {
    title: "Lavasa",
    description: "Lavasa is a planned hill city inspired by Italian towns, offering lakeside promenades, colorful architecture, and leisure activities. It is popular for relaxing drives and photography."
  },
  {
    title: "Pune",
    description: "Pune is a vibrant city known for its cultural heritage, educational institutions, forts, and modern lifestyle. Nearby attractions include Sinhagad Fort, hill stations, and historic landmarks."
  }
],



services: [
{
name: "Mumbai to Pune Taxi Fare",
description: "Mumbai to Pune taxi fare service provides transparent pricing for travelers planning comfortable intercity journeys between Mumbai and Pune. Vehicles such as sedan, Ertiga, and Innova ensure smooth expressway travel via the Mumbai–Pune Expressway. Professional drivers provide punctual pickup from homes, offices, hotels, railway stations, and airport terminals across Mumbai."
},
{
name: "Mumbai to Pune Car Rental",
description: "Mumbai to Pune car rental service offers convenient vehicle hire for travelers planning trips between the two major cities. Comfortable vehicles with experienced drivers ensure safe highway journeys. Ideal for business trips, family travel, and airport transfers."
},
{
name: "Mumbai to Pune Cab Charges",
description: "Mumbai to Pune cab charges service provides clear pricing details for intercity travel between Mumbai and Pune. Travelers can choose from sedan, Ertiga, and Innova vehicles depending on group size and comfort needs."
},
{
name: "Mumbai to Pune Cab Booking",
description: "Mumbai to Pune cab booking service allows passengers to easily reserve taxis for travel between Mumbai and Pune. Flexible booking options ensure convenient ride scheduling with comfortable vehicles."
},
{
name: "Cab Service from Mumbai to Pune",
description: "Cab service from Mumbai to Pune offers dependable transportation between the two cities. Comfortable vehicles and professional drivers ensure smooth and safe travel via the expressway."
},
{
name: "Car Hire from Mumbai to Pune",
description: "Car hire from Mumbai to Pune provides reliable vehicle rental with driver services for intercity travel. Spacious vehicles ensure comfortable journeys for families and corporate travelers."
},
{
name: "Mumbai to Pune by Taxi",
description: "Mumbai to Pune by taxi service offers convenient door-to-door transportation between the two cities. Comfortable vehicles and experienced drivers ensure safe and relaxed travel."
},
{
name: "Mumbai to Pune Rental Car",
description: "Mumbai to Pune rental car service offers comfortable vehicles suitable for long-distance travel. Ideal for business travel, tourism visits, and family trips between Mumbai and Pune."
},
{
name: "Mumbai to Pune Ertiga Car Rental",
description: "Mumbai to Pune Ertiga car rental provides comfortable 7-seater SUV transportation suitable for families and small groups. Spacious seating ensures relaxed highway travel."
},
{
name: "Mumbai to Pune Innova Crysta",
description: "Mumbai to Pune Innova Crysta service offers premium SUV transportation for passengers seeking luxury and comfort. Spacious interiors and smooth driving performance ensure comfortable journeys."
},
{
name: "Mumbai to Pune Sedan Cab Fare",
description: "Mumbai to Pune sedan cab fare service provides affordable pricing for travelers using sedan vehicles like Swift Dzire or Etios. Ideal for individuals and small families traveling between the two cities."
},
{
name: "Mumbai to Pune One Way Cab",
description: "Mumbai to Pune one way cab service offers convenient single-trip transportation without return charges. Comfortable vehicles and professional drivers ensure safe expressway travel."
},
{
name: "Mumbai to Pune Cab Fare",
description: "Mumbai to Pune cab fare service provides transparent pricing for passengers planning comfortable intercity travel between the two cities."
},
{
name: "Cheapest Cab Service in Mumbai",
description: "Cheapest cab service in Mumbai offers economical transportation options for city rides and outstation trips. Comfortable vehicles and professional drivers ensure safe travel."
},
{
name: "Mumbai Cab Service for Outstation",
description: "Mumbai cab service for outstation provides reliable transportation for travelers planning long-distance journeys from Mumbai to nearby cities like Pune, Nashik, and Lonavala."
},
{
name: "Mumbai to Pune Ertiga Cab Service",
description: "Mumbai to Pune Ertiga cab service provides comfortable 7-seater SUV transportation suitable for families and small groups traveling between the two cities."
},
{
name: "Mumbai to Pune Taxi Service",
description: "Mumbai to Pune taxi service offers dependable intercity transportation between Mumbai and Pune with comfortable vehicles and experienced drivers."
},
{
name: "Mumbai to Pune Cabs",
description: "Mumbai to Pune cabs provide reliable transportation services with comfortable vehicles suitable for long-distance highway travel."
},
{
name: "Mumbai to Pune Taxi",
description: "Mumbai to Pune taxi offers convenient transportation between the two cities with comfortable vehicles and professional drivers."
},
{
name: "Mumbai to Pune Cab Service",
description: "Mumbai to Pune cab service provides dependable intercity transportation with safe driving and punctual pickup services."
},
{
name: "Mumbai to Pune Taxi Service",
description: "Mumbai to Pune taxi service offers reliable travel options between the two cities with comfortable vehicles and experienced drivers."
},
{
name: "Mumbai to Pune Cab Booking",
description: "Mumbai to Pune cab booking service allows passengers to easily reserve taxis for travel between Mumbai and Pune with flexible booking options."
},
{
name: "Cab from Mumbai to Pune",
description: "Cab from Mumbai to Pune service offers convenient transportation between the two cities with comfortable vehicles and professional drivers."
},
{
name: "Mumbai to Pune Car Rentals",
description: "Mumbai to Pune car rentals provide reliable vehicle hire services suitable for business travel, tourism trips, and family journeys."
}
],

tableData: [
["Mumbai to Pune Taxi Fare","Mumbai to Pune Car Rental"],
["Mumbai to Pune Cab Charges","Mumbai to Pune Cab Booking"],
["Cab Service from Mumbai to Pune","Car Hire from Mumbai to Pune"],
["Mumbai to Pune by Taxi","Mumbai to Pune Rental Car"],
["Mumbai to Pune Ertiga Car Rental","Mumbai to Pune Innova Crysta"],
["Mumbai to Pune Sedan Cab Fare","Mumbai to Pune One Way Cab"],
["Mumbai to Pune Cab Fare","Cheapest Cab Service in Mumbai"],
["Mumbai Cab Service for Outstation","Mumbai to Pune Ertiga Cab Service"],
["Mumbai to Pune Taxi Service","Mumbai to Pune Cabs"],
["Mumbai to Pune Taxi","Mumbai to Pune Cab Service"],
["Mumbai to Pune Taxi Service","Mumbai to Pune Cab Booking"],
["Cab from Mumbai to Pune","Mumbai to Pune Car Rentals"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Mumbai to Pune via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Mumbai to Pune cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Pune cab service operates 24 hours a day. Whether you need an early morning ride, late night airport transfer, or urgent business travel, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Mumbai to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, airports, railway stations, and residential areas across Mumbai including Andheri, Bandra, Borivali, Thane, Navi Mumbai, and Dadar."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai to Pune cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Mumbai to Pune with professional drivers and comfortable vehicles." },
  { question: "How far is Mumbai from Pune?", answer: "The road distance between Mumbai and Pune is approximately 150 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Is Mumbai to Pune cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Mumbai to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Mumbai to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Mumbai and Pune." },
  { question: "Do you provide pickup from Mumbai Airport?", answer: "Yes, our drivers provide pickup from Mumbai Airport, homes, hotels, offices, and railway stations across Mumbai." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai to Pune cab services online or through phone booking." },
  { question: "Do you provide drop to Pune Airport or railway station?", answer: "Yes, Velocity Cabs provides drop services to Pune Airport, railway stations, and major locations across Pune." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Kulkarni",
    feedback:
      "Smooth highway ride from Mumbai to Pune with a very comfortable cab. The vehicle was clean, and the journey felt relaxed and well-managed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Deshmukh",
    feedback:
      "A very convenient Mumbai to Pune travel experience. The cab was punctual, the ride was steady, and everything felt safe and professionally handled.",
    rating: 5
  }
];





































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Mumbai to Pune cab service with affordable fares and professional drivers. Book one way and round trip taxis including Ertiga, Innova, Innova Crysta, and Sedan cabs for airport transfers, city-to-city travel, and corporate trips. Enjoy safe, comfortable, and punctual rides with easy online booking from Mumbai to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};







  return (
    <div>
      

<Helmet>
  <title>Mumbai to Pune Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pune cab with Velocity Cabs. Affordable one way, round trip & airport drop taxis including Ertiga, Innova, Innova Crysta & Sedan cabs for city-to-city travel, airport transfers & corporate trips." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/103.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopunecab;